import { render, staticRenderFns } from "./installation-inputs.vue?vue&type=template&id=6c80d601&scoped=true"
import script from "./installation-inputs.vue?vue&type=script&lang=js"
export * from "./installation-inputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c80d601",
  null
  
)

export default component.exports